import {
  InstantCardStatus,
  InstantCardType,
} from 'redux/services/instant-card/types'

export const INSTANT_CARD_STATUS_TEXT: Record<InstantCardStatus, string> = {
  [InstantCardStatus.connect]: 'Инициализировано',
  [InstantCardStatus.error]: 'Ошибка',
  [InstantCardStatus.give]: 'Выдано',
  [InstantCardStatus.ready]: 'Подготовка к выдаче',
}

export const INSTANT_CARD_TYPE_TEXT: Record<InstantCardType, string> = {
  [InstantCardType.mJunior]: 'MJunior',
  [InstantCardType.gold]: 'Visa Gold',
}

export const INSTANT_CARD_TYPE_OPTIONS = Object.entries(
  INSTANT_CARD_TYPE_TEXT,
).map(([value, title]) => ({
  value,
  title,
}))

export const INSTANT_CARD_REISSUE_TEXT: Record<string, string> = {
  false: 'Выпуск',
  true: 'Перевыпуск',
}

export const INSTANT_CARD_REISSUE_OPTIONS = Object.entries(
  INSTANT_CARD_REISSUE_TEXT,
).map(([value, title]) => ({
  value: String(value),
  title,
}))
